import React, { createContext, PropsWithChildren } from "react";
import { useChatChannelMembers } from "../../hooks/chat/useThreadMembers";
import { useChatChannelAbout } from "../../hooks/chat/useChatChannelAbout";

interface IChatChannelContext extends ReturnType<typeof useChatChannelMembers>, ReturnType<typeof useChatChannelAbout> { }

/** The chat channel context providing members list and functionality to all children */
export const ChatChannelContext = createContext<IChatChannelContext | undefined>(undefined);

interface IChatChannelContextProviderProps {
    /** The channel we are retrieving the info from */
    channelId: string;
}

export const ChatChannelContextProvider = ({ channelId, children }: PropsWithChildren<IChatChannelContextProviderProps>) => {
    const hookChannelResult = useChatChannelAbout(channelId);
    const hookMembersResult = useChatChannelMembers(channelId);
    const hookResult = {
        ...hookChannelResult,
        ...hookMembersResult,
        isLoading: hookChannelResult.isLoading || hookMembersResult.isLoading,
        error: [hookChannelResult.error, hookMembersResult.error].join(''),
    }
    return (
        <ChatChannelContext.Provider value={hookResult}>
            {children}
        </ChatChannelContext.Provider>
    );
};
